import { RubyPlayGameClientWrapper } from '@gongxigames/framework/integrations/rubyplay/RubyPlayGameClientWrapper';
import { RubyPlayGameClientWrapperSettings } from '@gongxigames/framework/integrations/rubyplay/RubyPlayGameClientWrapperSettings';
import { BetmgmPostMessageHandler } from '@gongxigames/framework/integrations/betmgm/BetmgmPostMessageHandler';

export class BetmgmGameClientWrapper extends RubyPlayGameClientWrapper {
    public static NAME = 'betmgm';

    protected _betmgmPostMessageHandler?: BetmgmPostMessageHandler;

    protected setupEvents(): void {
        super.setupEvents();

        this._eventManager.on('updateBalance', this.pingBalance.bind(this), this);
    }

    protected initParameters(): void {
        super.initParameters();

        const lang = this.getSettings<RubyPlayGameClientWrapperSettings>().get('lang');

        this._betmgmPostMessageHandler = new BetmgmPostMessageHandler(
            this._eventManager,
            this.emitter,
            this._browser,
            this._gameName,
            lang
        );
    }

    protected redirectToCashier(): void {
        this._betmgmPostMessageHandler?.onShowQuickDeposit();
    }

}
